const TOOLBAR_SELECTOR = '#th-controls-toolbar.library-sticky-toolbar';
const STUCK_CLASS = 'sticking';

// AIDEV-NOTE: CSS can't detect a pinned sticky element, hence the sentinel. The root is inset by
// the toolbar's own `top` (50px while masquerading) so the class flips exactly when it pins.
export default function initLibraryStickyToolbar() {
  const toolbar = document.querySelector<HTMLElement>(TOOLBAR_SELECTOR);
  if (!toolbar?.parentElement || typeof IntersectionObserver === 'undefined') return;

  const stickyTop = parseFloat(window.getComputedStyle(toolbar).top) || 0;

  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.height = '1px';
  sentinel.style.marginBottom = '-1px';
  toolbar.parentElement.insertBefore(sentinel, toolbar);

  const observer = new IntersectionObserver(
    ([entry]) => { toolbar.classList.toggle(STUCK_CLASS, !entry.isIntersecting); },
    { rootMargin: `-${stickyTop}px 0px 0px 0px` },
  );

  observer.observe(sentinel);
}
